var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41245 5.16239C4.30306 5.27175 4.15472 5.33318 4.00004 5.33318C3.84536 5.33318 3.69701 5.27175 3.58762 5.16239L0.287704 1.86248C0.23199 1.80867 0.18755 1.7443 0.156978 1.67313C0.126406 1.60196 0.110314 1.52541 0.109641 1.44796C0.108968 1.37051 0.123728 1.29369 0.153058 1.222C0.182389 1.15031 0.225703 1.08518 0.280474 1.03041C0.335244 0.975642 0.400375 0.932327 0.472064 0.902997C0.543754 0.873666 0.620567 0.858907 0.698021 0.85958C0.775476 0.860253 0.852021 0.876345 0.92319 0.906917C0.994359 0.937489 1.05873 0.981928 1.11254 1.03764L4.00004 3.92514L6.88754 1.03764C6.99756 0.931384 7.14491 0.872587 7.29785 0.873916C7.4508 0.875245 7.59711 0.936594 7.70526 1.04475C7.81342 1.1529 7.87477 1.29921 7.8761 1.45216C7.87743 1.60511 7.81863 1.75246 7.71237 1.86248L4.41245 5.16239Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.d61429ba01dc9ce8ad5ec0be5ebc5ef2.svg";
export { ForwardRef as ReactComponent };